export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholder404@2x.png";